import { useState, useContext } from "react";
import { useParams, useOutletContext } from "react-router-dom";
import * as translator from "../../../../utils/translator";
import { OrderDetailsContext } from "../MyAccountOrderDetails/MyAccountOrderDetails";
import "./MyAccountProductsList.css";
import outOfStockIcon from "../../../../icons/out-of-stock.svg";
import { WAIT_ALTERNATIVE_PRODUCT_CUSTOMER_DECISION, WAIT_AUTOMATIC_STOCK_ALLOCATION, CANNABIS_ID, WAIT_CUSTOMER_DECISION, ALTERNATIVE_TREATMENT_OFFERED } from "../../../../utils/consts";
const outOfStockStatusesForAlternativeOffer = [WAIT_ALTERNATIVE_PRODUCT_CUSTOMER_DECISION, WAIT_AUTOMATIC_STOCK_ALLOCATION];
const outOfStockStatusesForMakeDecision = [WAIT_CUSTOMER_DECISION];
const doctorAlternativeOfferStatuses = [ALTERNATIVE_TREATMENT_OFFERED];

interface MyAccountProductsListProps {
  detailData: { [key: string]: string }[]
}

const MyAccountProductsList: React.FC<MyAccountProductsListProps> = ({ detailData }) => {
  const [expanded, setExpanded] = useState(false);
  const { country } = useParams();
  const visibleItems = expanded ? detailData : detailData.slice(0, 3);
  const { setCurrentGlobalModalName } = useOutletContext<any>();
  const { products, orderStatus, mention } = useContext(OrderDetailsContext);

  const isCannabisOrder = mention?.includes('medical_cannabis') ?? false;
  
  const toggleExpanded = () => {
    setExpanded(!expanded);
  }

  return (
    <div>
      <ul className="my-account-products-list">
        {visibleItems.map((objectItem, index) => (
          <li
            className="my-account-products-list-item"
            key={index}
          >
            {Object.keys(objectItem).map((key) =>
              key === "image"
                ?
                <img
                  key={key}
                  className="product-image"
                  src={objectItem[key]}
                  alt="product"
                />
                :
                <div
                  className="account-order-detail-row-value-product-details-container"
                  key={key}
                >
                  {/* product title */}
                  <p className="account-order-detail-row-value">{objectItem[key]}</p>

                  {(outOfStockStatusesForAlternativeOffer.includes(orderStatus) && objectItem.type !== CANNABIS_ID) ? (
                    isCannabisOrder ? (
                      <div className="product-out-of-stock-actions">
                        {/* trigger for showing alternatives for out of stock products */}
                        <button
                          className="show-alternative-trigger"
                          onClick={() => setCurrentGlobalModalName({
                            type: "ALTERNATIVES_FOR_OUT_OF_STOCK",
                            orderProducts: products,
                          })}
                        >
                          {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/show_alternatives")}
                        </button>
                        {/* attention sign */}
                        <div className="account-order-detail-row-out-of-stock-attention">
                          <img src={outOfStockIcon} alt="" />
                          {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/out_of_stock")}
                        </div>
                      </div>
                    ) : (
                      <span className={`wait_10_days_status`}>{translator.translate(translator.getLanguageByCountry(country), "my_account", `MyOrders/details/alternative_offer_modal/wait_10_days_button`)}</span>
                    )
                  ) : null}

                  {outOfStockStatusesForMakeDecision.includes(orderStatus) && (
                    <div className="account-order-detail-row-out-of-stock-attention">
                      <img src={outOfStockIcon} alt="" />
                      {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/out_of_stock")}
                    </div>
                  )}

                  {doctorAlternativeOfferStatuses.includes(orderStatus) && (
                    <div className="not-approved-by-doctor-row">
                      <img
                        className="not-approved-x-icon"
                        src={require('../../../../icons/not-approved-x.png')}
                        alt=""
                      />
                      <span className="not-approved-by-doctor-badge">
                        {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/not_approved_by_doctor")}
                      </span>
                    </div>
                  )}

                </div>
            )}
          </li>
        ))}
      </ul>

      {detailData.length > 3 && expanded == false ? (
        <button onClick={toggleExpanded} className="expand">
          {translator.translate(
            translator.getLanguageByCountry(country),
            "my_account",
            "MyOrders/details/viewAll"
          ) + " "}
        </button>
      ) : null}


      {outOfStockStatusesForMakeDecision.includes(orderStatus) && (
        <div className="out-of-stock-decision-banner">
          <button
            className="show-alternative-trigger"
            onClick={() => setCurrentGlobalModalName({
              type: "ALTERNATIVES_FOR_OUT_OF_STOCK",
              orderProducts: products,
            })}
          >
            {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/show_options")}
          </button>
          <span className="out-of-stock-decision-text">
            {translator.translate(translator.getLanguageByCountry(country), "my_account", "MyOrders/details/alternative_offer_modal/make_decision")}
          </span>
        </div>
      )}
    </div>
  );
}

export default MyAccountProductsList;